// extracted by mini-css-extract-plugin
module.exports = {"container":"SponsoredBadge_container__biNpX","content":"SponsoredBadge_content__1lk_1"};